import type { Blocker } from 'react-router';
import { ConfirmDialog } from '../ui/confirm-dialog';

/** Asks before a navigation drops unsaved edits; the navigation goes on or is called off with the answer. */
export const LeaveDialog = ({ blocker, editing }: { blocker: Blocker; editing: boolean }) => (
	<ConfirmDialog
		open={blocker.state === 'blocked'}
		title='Discard changes?'
		confirmLabel='Discard'
		cancelLabel='Keep editing'
		onConfirm={() => blocker.proceed?.()}
		onCancel={() => blocker.reset?.()}
	>
		{editing
			? 'Your changes are not saved. If you leave now, the tool stays as it was.'
			: 'This tool is not created yet. If you leave now, your steps are lost.'}
	</ConfirmDialog>
);
